<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogClient"
    :before-close="doClose"
    width="90%"
    top="5%"
    class="abow_dialog"
    :modal-append-to-body="false"
  >
    <template>
      <div class="tableDiv">
        <el-table
          :data="tableCCN"
          :empty-text="$t('desc.noData')"
          :row-class-name="setClassName"
          class="demo-table-expand"
          stripe
          style="width: 100%"
          row-key="name"
          :expand-row-keys="tableType == 'monitor' ? ['空压机状态字'] : []"
        >
          <el-table-column type="index" :label="$t('title.serialNumber')" width="60">
          </el-table-column>
          <el-table-column prop="name" :label="$t('title.Index')" min-width="100">
          </el-table-column>
          <el-table-column type="expand" min-width="50">
            <template slot-scope="props">
              <el-form
                label-position="right"
                class="demo-table-expand"
                label-width="100px"
              >
                <template v-for="state in props.row.stateList">
                  <el-form-item
                    :label="tableType == 'monitor' ? '' : state.name"
                    :key="state.name"
                  >
                    <span>{{ state.value }}</span>
                  </el-form-item>
                </template>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column prop="value" :label="$t('title.number')" min-width="100">
            <template slot-scope="scope">
              {{
                tableType == "monitor" && scope.row.value.indexOf("=>") > 0
                  ? ""
                  : scope.row.value
              }}
            </template>
          </el-table-column>
          <el-table-column prop="unit" :label="$t('title.monitorUnit')" min-width="80">
          </el-table-column>
          <el-table-column prop="time" :label="$t('title.time')" min-width="120">
          </el-table-column>
        </el-table>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "index",
  props: {
    dialogClient: false,
    tableType: "",
    title: "",
    tableCCN: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      showEDiv: false,
      KTarget: {},
      // tableCCN: [
      //   {
      //     expand: true,
      //     name: "空压机状态字",
      //     value: "192=>110000",
      //     unit: "",
      //     time: "",
      //     state1: "1111",
      //     state2: "2222",
      //     state3: "3333",
      //     state4: "44444",
      //     state5: "55555",
      //   },
      //   {
      //     expand: false,
      //     name: "上电时间",
      //     value: "0",
      //     unit: "hour",
      //     time: "2021-02-25 16:54:21",
      //   },
      // ],
    };
  },
  methods: {
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.KTarget = {
        value1: new Array(),
      };
      //   this.$refs.gsnForm.resetFields();
    },
    setClassName({ row, rowIndex }) {
      return row.expand ? "" : "expand";
    },
  },
};
</script>

<style>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 10px !important;
  margin-top: 0 !important;
  /* width: 25%; */
}
.demo-table-expand .el-form-item__label {
  color: #909399;
  position: initial !important;
  transform: initial !important;
}
.demo-table-expand .el-form-item__content {
  color: #fff !important;
  vertical-align: middle;
}
.demo-table-expand .expand .el-table__expand-column .cell {
  display: none !important;
}
.demo-table-expand tr td.el-table__expanded-cell {
  background: #f3f3f3;
}
</style>
